import React from 'react';
import { Box, Container } from '@mui/material';
import { DepartmentDetails } from '../../components/Department/DepartmentDetails';

export const InvDepartmentDetailsPage = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(180deg, #f9fafc 0%, #f2f5f8 100%)',
      }}
    >
      <Container maxWidth="xl">
        <Box sx={{ py: 4 }}>
          <DepartmentDetails />
        </Box>
      </Container>
    </Box>
  );
};
